import { useState, useEffect, useRef } from 'react';
import logo from '../../img/logo.jpeg';
import { useNavigate, useLocation } from 'react-router-dom';

const Header = () => {
    const navigate = useNavigate();
    const location = useLocation(); // Get the current location
    const [showSidebar, setShowSidebar] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const sidebarRef = useRef(null); // Reference to the sidebar
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768); // State to track screen size
    const [scrollTarget, setScrollTarget] = useState(null); // Track the target ID to scroll to

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 800) {
                setIsScrolled(true); // Add opacity when scrolled down
            } else {
                setIsScrolled(false); // Reset opacity when at the top
            }
        };

        window.addEventListener('scroll', handleScroll);

        // Cleanup event listener on component unmount
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
                setShowSidebar(false); // Close the sidebar if clicked outside
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        // Cleanup event listener on component unmount
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 992); // Update state based on screen size
        };

        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        setIsMobile(window.innerWidth <= 992);
    }, []);
    // Scroll to the target element after navigation
    useEffect(() => {
        if (scrollTarget) {
            const element = document.getElementById(scrollTarget);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
                setScrollTarget(null); // Reset the scroll target after scrolling
            }
        }
    }, [location, scrollTarget]); // Run this effect when the location or scrollTarget changes

    return (
        <header id="header" className={isScrolled ? 'header-scrolled' : ''}>
            <div className="container">
                <div className="row align-items-center justify-content-between d-flex">
                    <div id="logo" style={{ borderRadius: '50%', overflow: 'hidden' }}>
                        <img
                            src={logo}
                            alt="logo"
                            title="Alkapoor Baptist Church"
                            className='cursor-pointer'
                            draggable="false"
                            onClick={() => {
                                if (window.location.pathname !== '/') {
                                    navigate('/');
                                }
                                window.scrollTo({ top: 0 });
                                setShowSidebar(false);
                            }}
                        />
                        <button
                            onClick={() => {
                                setShowSidebar(prev => {
                                    if (prev === false) {
                                        return true;
                                    } else {
                                        return false;
                                    }
                                }
                                );
                            }}
                            style={{ background: 'none', border: 'none', cursor: 'pointer' }}
                            type="button"
                            id="mobile-nav-toggle"
                        >
                            <i style={{ fontSize: "30px" }} className="lnr lnr-menu"></i>
                        </button>
                    </div>
                    <div className="header-top">
                        <div className="container header-details">
                            <ul>
                                <li>Sunday: 11am to 12:30pm</li>
                                <li>
                                    <p>+91 9949694-869</p>
                                </li>
                            </ul>
                        </div>
                        <nav
                            id={isMobile ? "mobile-nav" : "nav-menu-container"}
                            ref={sidebarRef} // Attach the ref to the sidebar
                            className={showSidebar ? 'active' : ''}
                        >
                            <ul className="nav-menu">
                                <li>
                                    <button
                                        onClick={() => {
                                            if (window.location.pathname !== '/') {
                                                navigate('/');
                                            }
                                            window.scrollTo({ top: 0 });
                                            setShowSidebar(false);
                                        }}
                                    >
                                        Home
                                    </button>
                                </li>
                                <li>
                                    <a href="#about" onClick={() => { navigate('/'); setShowSidebar(false); }}>
                                        About
                                    </a>
                                </li>
                                <li>
                                    <a href="#location" onClick={() => { navigate('/'); setShowSidebar(false); }}>
                                        Location
                                    </a>
                                </li>
                                <li>
                                    <button
                                        onClick={() => {
                                            navigate('/bible');
                                            window.scrollTo({ top: 0 });
                                            setShowSidebar(false);
                                        }}
                                    >
                                        Bible
                                    </button>
                                </li>
                                <li>
                                    <button
                                        onClick={() => {
                                            navigate('/vision');
                                            window.scrollTo({ top: 0 });
                                            setShowSidebar(false);
                                        }}
                                    >
                                        Vision
                                    </button>
                                </li>
                                <li>
                                    <button
                                        onClick={() => {
                                            navigate('/mission');
                                            window.scrollTo({ top: 0 });
                                            setShowSidebar(false);
                                        }}
                                    >
                                        Mission
                                    </button>
                                </li>
                                <li>
                                    <button
                                        onClick={() => {
                                            navigate('/team');
                                            window.scrollTo({ top: 0 });
                                            setShowSidebar(false);
                                        }}
                                    >
                                        Team
                                    </button>
                                </li>
                                <li>
                                    <button
                                        onClick={() => {
                                            navigate('/privacy');
                                            window.scrollTo({ top: 0 });
                                            setShowSidebar(false);
                                        }}
                                    >
                                        Privacy Policy
                                    </button>
                                </li>
                                <li>
                                    <button
                                        onClick={() => {
                                            navigate('/contact');
                                            window.scrollTo({ top: 0 });
                                            setShowSidebar(false);
                                        }}
                                    >
                                        Contact
                                    </button>
                                </li>
                            </ul>
                        </nav>
                    </div>
                </div>
                {isMobile &&
                    <div className='mobile-body-overlay' style={{ opacity: showSidebar ? 0.5 : 0, zIndex: showSidebar ? '10' : '-1', visibility: showSidebar ? "visible" : "hidden" }}></div>
                }
            </div>
        </header>
    );
};

export default Header;